import { render, staticRenderFns } from "./KefuComp.vue?vue&type=template&id=52b66b5a&scoped=true"
import script from "./KefuComp.vue?vue&type=script&lang=js"
export * from "./KefuComp.vue?vue&type=script&lang=js"
import style0 from "./KefuComp.vue?vue&type=style&index=0&id=52b66b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b66b5a",
  null
  
)

export default component.exports